<template>
  <v-text-field v-model="text" :rules="rules" :label="label" :counter="counter" :maxlength="maxlength" :color="color" @change="change" @input="input" :prepend-icon="prependIcon" :append-icon="appendIcon" :suffix="suffix" :disabled="disabled" dense>
  </v-text-field>
</template>

<script>
export default {
  name: "RyouInput",
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      // type: String,
      required: false
    },
    maxlength: {
      type: Number,
      required: false
    },
    counter: {
      type: String,
      required: false,
      default: ""
    },
    color: {
      type: String,
      required: false,
      default: ""
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    prependIcon: {
      type: String,
      required: false
    },
    appendIcon: {
      type: String,
      required: false
    },
    suffix: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    change(val) {
      this.$emit("change", val);
    },
    input(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped>
</style>
